import betJumpUrl from '../assets/audio/jump.mp3?url'
import cashoutUrl from '../assets/audio/cashout.mp3?url'
import runOverUrl from '../assets/audio/runOver.mp3?url'
import winUrl from '../assets/audio/win.mp3?url'
import carBrakingUrl from '../assets/audio/carBraking.mp3?url'

export type ChickenSoundKey = 'jump' | 'cashout' | 'death' | 'win' | 'carBrake'

const SFX_DEFAULT_VOLUME = 0.5

export class SoundManager {
	private static _instance: SoundManager | null = null
	private isMuted = false
	private loaded = false
	private volume = SFX_DEFAULT_VOLUME
	private readonly sources: Record<ChickenSoundKey, string> = {
		jump: betJumpUrl,
		cashout: cashoutUrl,
		death: runOverUrl,
		win: winUrl,
		carBrake: carBrakingUrl,
	}

	static get instance() {
		if (!this._instance) {
			this._instance = new SoundManager()
		}

		return this._instance
	}

	async load() {
		if (this.loaded) {
			return
		}

		await Promise.all(
			Object.values(this.sources).map(
				(src) =>
					new Promise<void>((resolve) => {
						const audio = new Audio(src)
						audio.preload = 'auto'
						audio.oncanplaythrough = () => resolve()
						audio.onerror = () => resolve()
					}),
			),
		)

		this.loaded = true
	}

	play(key: ChickenSoundKey) {
		if (this.isMuted) {
			return
		}

		const src = this.sources[key]
		if (!src) {
			return
		}

		try {
			const audio = new Audio(src)
			audio.volume = this.volume
			void audio.play().catch(() => undefined)
		} catch {
			// Audio unavailable.
		}
	}

	stopAll() {
		// Cloned audio elements stop automatically.
	}
}
